/**
 * Event constants for the Hyve Phaser Plugin
 */
export const HyveEvents = {
  /** Fired when authentication completes (success or failure) */
  AUTHENTICATED: 'hyve-authenticated',
  /** Fired when telemetry is successfully sent */
  TELEMETRY_SENT: 'hyve-telemetry-sent',
  /** Fired when telemetry fails to send */
  TELEMETRY_ERROR: 'hyve-telemetry-error',
  /** Fired when plugin is initialized */
  PLUGIN_READY: 'hyve-plugin-ready',
} as const;

export type HyveEventType = typeof HyveEvents[keyof typeof HyveEvents];